import { createSelector } from "reselect";
import { PLANNED, SAME_DAY } from "../../consts/collections";
import { OUTER } from "../../consts/layers";
import { Postcode } from "../../utils/postcode";

export const getSelectedDepot = (state) => state.ownApp.selectedDepot;
export const selectedTimeBandSelector = (state) =>
  state.ownApp.selectedTimeBand;
export const previousSelectedTimeBandSelector = (state) =>
  state.ownApp.previousSelectedTimeBand;
export const selectedRouteSelector = (state) => state.ownApp.selectedRoute;
export const selectedDriverSelector = (state) => state.ownApp.selectedDriver;
export const selectedLocationSelector = (state) =>
  state.ownApp.selectedLocation;
export const selectedSectionSelector = (state) => state.ownApp.selectedSection;
export const selectedShiftManagerSelector = (state) =>
  state.ownApp.selectedShiftManager;
export const selectedDriverDaySelector = (dayOfWeek) => (state) =>
  state.ownApp.selectedDriver?.driverDayEdits?.[dayOfWeek];
export const editMapModalOpenSelector = (state) =>
  state.ownApp.editMapModalOpen;
export const addArtificialPostcodeModalOpenSelector = (state) =>
  state.ownApp.addArtificialPostcodeModalOpen;
export const addDriverModalOpenSelector = (state) =>
  state.ownApp.addDriverModalOpen;
export const addSectionModalOpenSelector = (state) =>
  state.ownApp.addSectionModalOpen;
export const addRouteModalOpenSelector = (state) =>
  state.ownApp.addRouteModalOpen;
export const selectPlanModalOpenSelector = (state) =>
  state.ownApp.selectPlanModalOpen;
export const createNewTemplateModalOpenSelector = (state) =>
  state.ownApp.createNewTemplateModalOpen;
export const createDatedPlanModalOpenSelector = (state) =>
  state.ownApp.createDatedPlanModalOpen;
export const showReloadPlanManagementSelector = (state) =>
  state.ownApp.showReloadPlanManagement;
export const showReloadDriverManagementSelector = (state) =>
  state.ownApp.showReloadDriverManagement;
export const planManagementReloadModalOpenSelector = (state) =>
  state.ownApp.planManagementReloadModalOpen;
export const driverManagementReloadModalOpenSelector = (state) =>
  state.ownApp.driverManagementReloadModalOpen;
export const driverManagementExpiredModalOpenSelector = (state) =>
  state.ownApp.driverManagementExpiredModalOpen;
export const planManagementExpiredModalOpenSelector = (state) =>
  state.ownApp.planManagementExpiredModalOpen;
export const copyModalOpenSelector = (state) => state.ownApp.copyModalOpen;
export const driversLockedErrorSelector = (state) =>
  state.ownApp.driversLockedError;
export const weekendRouteOverlapWarningSelector = (state) =>
  state.ownApp.weekendRouteOverlapWarning;
export const depotLockedErrorSelector = (state) =>
  state.ownApp.depotLockedError;
export const editPlanModalOpenSelector = (state) =>
  state.ownApp.editPlanModalOpen;
export const notificationsSelector = (state) => state.ownApp.notifications;
export const unlockPlanModalOpenSelector = (state) =>
  state.ownApp.unlockPlanModalOpen;
export const unlockDepotModalOpenSelector = (state) =>
  state.ownApp.unlockDepotModalOpen;
export const unlockDriversDayModalOpenSelector = (state) =>
  state.ownApp.unlockDriversDayModalOpen;
export const unlockDriversWeekModalOpenSelector = (state) =>
  state.ownApp.unlockDriversWeekModalOpen;
export const unlockMatrixWeekModalOpenSelector = (state) =>
  state.ownApp.unlockMatrixWeekModalOpen;
export const routeEditOptionsModalOpenSelector = (state) =>
  state.ownApp.routeEditOptionsModalOpen;
export const routeEditOptionsModalMessage = (state) =>
  state.ownApp.routeEditOptionsModalMessage;
export const routeEditOptionsModalOptionsSelector = (state) =>
  state.ownApp.routeEditOptionsModalOptions;
export const pickupEditOptionsModalOpenSelector = (state) =>
  state.ownApp.pickupEditOptionsModalOpen;
export const pickupEditOptionsModalOptionsSelector = (state) =>
  state.ownApp.pickupEditOptionsModalOptions;
export const postcodeInUseModalContentSelector = (state) =>
  state.ownApp.postcodeInUseModalContent;
export const determinateLoadingSelector = (state) =>
  state.ownApp.determinateLoading;
export const showOptimiseAllSelector = (state) => state.ownApp.showOptimiseAll;
export const selectedTabSelector = (state) => state.ownApp.selectedTab;
export const collectionEditPostcodeSelector = (state) =>
  state.ownApp.collectionEditPostcode;
export const collectionTimeEditSelector = (state) =>
  state.ownApp.collectionTimeEdit;
export const appLoadingSelector = (state) => state.ownApp.loading;
export const markerViewTypeSelector = (state) => state.ownApp.markerViewType;
export const editOverridesModalOpenSelector = (state) =>
  state.ownApp.editOverridesModalOpen;
export const editPickupModalOpenSelector = (state) =>
  state.ownApp.editPickupModalOpen;
export const selectedPostcodesSelector = (state) =>
  state.ownApp.selectedPostcodes;
export const simulatedOverlayOpenSelector = (state) =>
  state.ownApp.selectSimulatedOverlayOpen;
export const selectedOverlaySimulationPercentageSelector = (state) =>
  state.ownApp.selectedOverlaySimulationPercentage;
export const selectedPostcodesLevelSelector = createSelector(
  selectedPostcodesSelector,
  ([selectedPostcode] = []) =>
    selectedPostcode ? Postcode.getLevel(selectedPostcode) : OUTER
);

export const selectedCollectionTabSelector = createSelector(
  selectedTabSelector,
  (selectedTab) => {
    switch (selectedTab) {
      case "Same Day":
        return SAME_DAY;
      case "Planned":
        return PLANNED;
      default:
        return PLANNED;
    }
  }
);
